/*global page */
var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'fb_share';
  var pageManager = fc.pageManager;
  var fb = fc.fb;

  var currentPage = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);

  currentPage.html = `<h1><img src="/assets/app/logo.svg" id="logo"></h1><div class="content" id="form"><p class="upper">Say something about<br>your amazing selfie:</p><div class="middle"><form class="c_wrap"><textarea id="caption"></textarea></form></div></div><div class="content hidden" id="posting"><p class="upper">Posting selfie to facebook</p></div><footer class=""><a href="/backgrounds" class="button"><img src="/assets/app/xbutton.svg"></a><span></span><span class="button" id="okbutton"><img src="/assets/app/okbutton.svg"></span></footer>`;

  var postToFacebook = function () {
    var textarea = this.$$('#caption'),
        postingForm = this.$$('#form'),
        posting = this.$$('#posting'),
        footer = this.$$('footer'),
        accessToken = fc.appState.accessToken;

    fc.ga('/share_started');

    postingForm.classList.add('hidden');
    footer.classList.add('hidden');
    posting.classList.remove('hidden');

    fb.uploadPhoto(textarea.value, fc.appState.finalBlob, accessToken)
      .then(function () {
        page.redirect('/credits');
      })
      .catch(function () {
        alert('Something went wrong :(');
        page.redirect('/backgrounds');
      });

  }.bind(currentPage);

  currentPage.eventHandlers = [{
    event: 'click',
    target: '#okbutton',
    handler: postToFacebook
  }, {
    event: 'submit',
    target: 'form',
    handler: postToFacebook
  }];

  pageManager.add(currentPage);

}(FakeCation));
